export class DrugToDiseaseInteraction {
  public selectedIngredientId: number;
  public selectedIngredientName: string;
  public diseaseId: number;
  public diseaseName: string;
  public interactionTypeId: number;
  public consumerDecscription: string;
  public professionalDecscription: string;
}